module.exports = __webpack_public_path__ + "static/media/trace_moment.88afde15.jpg";